import React, { useState } from 'react';
import { Row, Col, Stack } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import { showMessage } from '../../../../../../common/Helpers';
import MessageBox from '../../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import DataserieCloseChecks from './DataserieCloseChecks';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import MessageBoxInfoComplex from '../../../../../Common/Message/MessageBoxInfoComplex';
import { postDataserieValueCloseProcess } from '../../../../../../services/sKPI/dataserie.service';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import CLabel from '../../../../../Common/CLabel';
import { Checkbox } from '@fluentui/react';

const SidePanelDataserieClose = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_BoardId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerieList = null,
        inputParam_ElementId = null,
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [isValidForm, setIsValidForm] = useState({
        v1: true,
        v2: true,
        valueReal: true,
        valueProvisory: true,
        valueBudget: true,
        valueForecast: true,
    });
    
    const [closeEnd, setCloseEnd] = useState(false)
    const [objDataserieList, setObjDataserieList] = useState(inputParam_DataSerieList)
    const [objDataserieSelectedList, setObjDataserieSelectedList] = useState(inputParam_DataSerieList)

    const validateForm = () => {
        let isValid =(objDataserieList !== null && objDataserieList.length > 0) ? true : false;

        setIsValidForm(isValidForm)

        return isValid
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)

        setIsValidForm({
            v1: true,
            v2: true,
            valueReal: true,
            valueProvisory: true,
            valueBudget: true,
            valueForecast: true,
        });
    };

    const onCheckboxCheckedChange = (event, checked, dataserie) => {
        let updatedList = [...objDataserieSelectedList];
    
        if (checked) {
            updatedList.push(dataserie);
        }
        else {
            updatedList = objDataserieSelectedList.filter((item, index, self) => {
                return (
                    self.findIndex((t) => t.dataserieId === item.dataserieId) === index
                );
            }).filter(x => x.dataserieId !== dataserie.dataserieId);
        }
        
        setObjDataserieSelectedList(updatedList);
    }

    const onCloseDataseries = () => {
        if (validateForm()) {
            postDataserieValueCloseProcess(inputParam_ElementId, true,
                contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
                contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate,
                objDataserieSelectedList.map(x => x.dataserieId)
            ).then((response) => {
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    setCloseEnd(true)
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setCloseEnd(false)
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setCloseEnd(false)
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectoneelement'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            inputParam_ElementId && (inputParam_DataSerieList && inputParam_DataSerieList.length > 0) && !closeEnd &&
                            <PrimaryButton onClick={ onCloseDataseries } styles={_global_buttonStyles}>{ t('data-lang-btn-closedataseries') }</PrimaryButton>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-closedataseries') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-2">
                    <Col>
                        <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-dataseriestocloseprocess')}`} />
                    </Col>
                </Row>
                <Row className="pt-4">
                    <Col>
                        <div><b>{t('data-lang-lbl-availabledataseries')}</b></div>
                    </Col>
                </Row>
                <Row className="pt-2">
                    <Col>
                            <>
                            {
                                ((inputParam_DataSerieList && inputParam_DataSerieList.length > 0) === true) &&
                                <Stack tokens={{ childrenGap: 10 }}>
                                {
                                    inputParam_DataSerieList.map((dataserie, index) => 
                                        <Checkbox
                                            key={index}
                                            label={<div>
                                                        <div className='ps-1'>
                                                            <b>{dataserie.variableName}</b>
                                                        </div>
                                                        <div className='ps-1' style={{fontSize: "smaller"}}><b> ({dataserie.um})</b></div>
                                                    </div>}
                                            checked={inputParam_DataSerieList.length === 1 ? true : (objDataserieSelectedList.find(x => x.dataserieId === dataserie.dataserieId) !== undefined)}
                                            disabled={inputParam_DataSerieList.length === 1}
                                            onChange={(event, checked) => onCheckboxCheckedChange(event, checked, dataserie)}
                                        />
                                    )
                                }
                            </Stack>
                            }
                            </>
                        {
                            ((inputParam_DataSerieList && inputParam_DataSerieList.length > 0) === false) &&
                            <MessageBox
                                inputParam_Message={ t('data-lang-msg-nodataseriesavailable') }
                                inputParam_Display={ true }
                                inputParam_MessageType={ __MessageTypes.WARNING }
                                inputParam_SetterMessage={ null }
                            />
                        }
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelDataserieClose.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerieList: PropTypes.array.isRequired,
    inputParam_ElementId: PropTypes.number.isRequired,
};

export default SidePanelDataserieClose;